export default __webpack_public_path__ + "7402aae9f2c5497893c7f5792a0507ce.png";